import { io } from 'socket.io-client';
const PORT = 3241;
export const SocketIO = io(`http://toobz.live:3241`);